import React, {useState, useCallback} from 'react';
import classNames from 'classnames';
import {Grid, GridCol, Tooltip} from '@flixbus/honeycomb-react';
import {Icon, IconQuestion} from '@flixbus/honeycomb-icons-react';
import {LabelWithTooltipProps} from './LabelWithTooltip.types';

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  label,
  htmlFor,
  tooltipProps,
  disabled
}) => {
  const [activeTooltip, setActiveTooltip] = useState(false);

  const TooltipInlineIcon = useCallback(
    () => (
      <IconQuestion
        style={{cursor: 'pointer', marginTop: '-3px'}}
        aria-label="Input Info Icon"
      />
    ),
    []
  );

  return (
    <Grid
      extraClasses={classNames(
        'no-wrap',
        disabled ? 'pointer-events-none' : ''
      )}
    >
      <GridCol inline extraClasses="ellipsis-text">
        <label htmlFor={htmlFor}>{label}</label>
      </GridCol>
      <GridCol inline>
        <Tooltip {...tooltipProps} active={activeTooltip}>
          <Icon
            size={4}
            InlineIcon={TooltipInlineIcon}
            onMouseOver={() => setActiveTooltip(true)}
            onMouseOut={() => setActiveTooltip(false)}
            onBlur={() => setActiveTooltip(false)}
          />
        </Tooltip>
      </GridCol>
    </Grid>
  );
};

const MemoizedComponent = React.memo(LabelWithTooltip);
MemoizedComponent.displayName = 'LabelWithTooltip';

export default MemoizedComponent;
